export default __webpack_public_path__ + "static/media/register-kids.57c480c6.png";